import { VaultedSecretAccess } from "@p0security/integrations-vaulted-credential-shared";
import { Access } from "@p0security/shared/types/access/index";

export const CloudflareAiAccesses = {
  permission: Access({
    description:
      "Permission groups in a Cloudflare account, granted via a shared NHI credential",
    label: "Permission",
    maturity: "beta",
    ...VaultedSecretAccess,
    parameters: {
      account: {
        type: "dynamic",
        label: "Account",
        description: "Cloudflare account",
      },
      // Without a zone, the groups apply to the account. "*" is every zone of
      // the account, also zones added later.
      zone: {
        type: "dynamic",
        label: "Zone",
        description: "Cloudflare zone, by name, or * for all zones",
        optional: true,
      },
      // Values are Cloudflare permission group ids, shown by name.
      policies: {
        type: "dynamic",
        label: "Permission groups",
        description: "Permission groups to grant on the account or zone",
        multivalued: true,
      },
      // Read from the connector when the request is made, in the order of
      // `policies`, so a rule and an approver see names, not ids.
      policyNames: {
        type: "generated",
        label: "Permission group names",
        description: "The permission groups' names in Cloudflare",
        multivalued: true,
      },
    },
    render: {
      locator: "account",
      policy: "policies",
    } as const,
  }),
};

export type CloudflareAiAccesses = typeof CloudflareAiAccesses;
export type CloudflareAiAccess =
  CloudflareAiAccesses[keyof CloudflareAiAccesses];
export type CloudflareAiPermissionAccess = CloudflareAiAccesses["permission"];
